/*
 * @Description:所有HTTP请求统一服务
 * @Author: wang.jiang
 * @LastEditors: Please set LastEditors
 * @Date: 2015/9/23
 */
'use strict';
angular.module('util.httpService', []).factory('trsHttpService', [
    '$injector',
    '$http',
    '$rootScope',
    '$q',
    'localStorageService',
    '$sessionStorage',
    'messagePublishService',
    function ($injector, $http, $rootScope, $q, localStorageService, $sessionStorage, messagePublishService) {
        let refreshTokenMaxTimes = 3;
        let refreshTokenTimes = 0;
        let modalDialog = $injector.get('modalDialog');
        // let globleParamsSet = $injector.get('globleParamsSet');

        /**
         * [removeGroupInfo description]清除当前用户的所属组织信息
         * @return {[type]} [description]
         */
        function removeGroupInfo() {
            let mlfCachedUser = $sessionStorage.get('mlfCachedUser');
            if (mlfCachedUser) {
                delete mlfCachedUser.GroupId;
                delete $rootScope.userGroupId;
                // $sessionStorage.set('mlfCachedUser', mlfCachedUser);
                // $sessionStorage.set('currLoginUser', '');
            }
            $sessionStorage.remove('currLoginUser');
            $sessionStorage.remove('mlfCachedUser');
            $sessionStorage.remove('curUserInfo');
            localStorageService.remove('userToken'); // 新增清除用户token
            $sessionStorage.remove('userHeadPic');
            $sessionStorage.cookie.remove('userToken');
            $sessionStorage.remove('strongPromtInfo');
            $sessionStorage.remove('global.strongWindowNewsDailyInfo');
            $sessionStorage.remove('global.sendNoticeOnlogin');
            localStorageService.remove('ls.global.loginMark'); // 去除用户登录标识
            // globleParamsSet.clearStroge(); // 循环依赖无法解决
        }

        /**
         * [goToLoginPage description] 进入登录页
         * @param   {[String]}  addr  [addr description]  ids登录页地址
         * @param   {[String]}  surl  [surl description]  wcm校验登录jsp地址并拼接登录后跳转的前端地址
         * @return  {[type]}          [return description]
         */
        function goToLoginPage(addr, surl) {
            let curUrl = window.location.href.split('#')[0]; // 当前访问的前端地址
            LazyLoad.js(['./lib/js-base64/base64.js'], function () {
                curUrl = Base64.encode(curUrl);
                curUrl = Base64.encode(surl + curUrl);
                window.location.href = addr + curUrl;
            });
        }

        return {
            // forbiddenError为true时为无报错模式
            httpServer: function (url, params, type, forbiddenError, header) {
                var deferred = $q.defer();
                handlePost(url, params, type, forbiddenError, header).then(
                    function (data) {
                        deferred.resolve(data);
                    },
                    function (data) {
                        deferred.reject(data);
                    },
                );
                return deferred.promise;
            },
            httpServerForNewspaperRemark: function (url, params, type, token) {
                var deferred = $q.defer();
                type = angular.uppercase(type);
                var headers = {
                    formdata: '1',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                };
                if (token) {
                    headers.token = token;
                }
                $http({
                    method: type,
                    url: url,
                    headers: headers,
                    data: type === 'POST' ? params : '',
                    params: type === 'POST' ? '' : params,
                })
                    .success(function (data, status, headers, config) {
                        if ((data.code && data.code === '200') || (data.CODE && data.CODE === '200')) {
                            deferred.resolve(data);
                        } else {
                            // 不等于200的暂时都视作失败
                            modalDialog.alertType('操作失败', '请稍后重试', 'warning');
                            deferred.reject(data);
                        }
                    })
                    .error(function (data, status) {
                        messagePublishService.publish('requetDataFailed');
                        deferred.reject(data);
                    });
                return deferred.promise;
            },
            httpServerForOC: function (params, type, forbiddenError) {
                var deferred = $q.defer();
                var serviceid = params.serviceid;
                var methodname = params.methodname;
                delete params.serviceid;
                delete params.methodname;
                handlePost('/oc/' + serviceid + '/' + methodname, params, type, forbiddenError).then(
                    function (data) {
                        deferred.resolve(data);
                    },
                    function (data) {
                        modalDialog.alertType(data.exception, data.message, 'error', false);
                        deferred.reject(data);
                    },
                );
                return deferred.promise;
            },
            getWCMRootUrl: function () {
                return getURL('WCMROOT');
            },
            getBigDataRootUrl: function () {
                var rootUrl = '/wcm/bigdata.do';
                return rootUrl;
            },
            getWeiboRootUrl: function () {
                return '/wcm/rbcenter.do';
            },
            getLogManageUrl: function () {
                var rootUrl = '/wcm/mlflog.do';
                return rootUrl;
            },
            getLoginServiceUrl: function () {
                var loginUrl = '/wcm/security/login';
                return loginUrl;
            },
            getUploadUrl: function () {
                var uploadUrl = '/wcm/openapi/uploadImage';
                return uploadUrl;
            },
            getWeiboUploadUrl: function () {
                var weiboUploadUrl = '/wcm/openapi/uploadImageForMicroBlog';
                return weiboUploadUrl;
            },
            getCheckLoginUrl: function () {
                var checkLoginUrl = '/wcm/security/checkLogin';
                return checkLoginUrl;
            },
            getPaymentSystem: function () {
                var loadUrl = '/wcm/stlogin/mrslogin';
                return loadUrl;
            },
            getMessageUrl: function () {
                // 消息中心接口
                var rootUrl = '/wcm/message.do';
                return rootUrl;
            },
            // 媒资库素材库RESTFUL请求
            httpServerForMR: function (params, data, isArrayBuffer) {
                var deferred = $q.defer();
                httpServerForMR(params, data, isArrayBuffer).then(function (data) {
                    deferred.resolve(data);
                });
                return deferred.promise;
            },

            getMRURL: function () {
                return getURL('MR');
            },
        };

        /**
         * [httpServerForMR 媒资库请求封装]
         *
         * @param   {[type]}  params         [params description]
         * @param   {[type]}  data           [data description]
         * @param   {[type]}  isArrayBuffer  [isArrayBuffer description]
         *
         * @return  {[type]}                 [return description]
         */
        function httpServerForMR(params, data, isArrayBuffer) {
            var deferred = $q.defer();
            if ($sessionStorage.cookie.get('userToken') && $sessionStorage.cookie.get('userToken') !== '') {
                sendMRRrequest(params, data, isArrayBuffer).then(function (data) {
                    deferred.resolve(data);
                });
            } else {
                refreshToken().then(function () {
                    httpServerForMR(params, data, isArrayBuffer).then(function (data) {
                        deferred.resolve(data);
                    });
                });
            }
            return deferred.promise;
        }

        // 发送媒资请求
        // eslint-disable-next-line require-jsdoc
        function sendMRRrequest(params, data, isArrayBuffer) {
            var deferred = $q.defer();
            let url = params.url;
            let method = params.method;
            let token = '';
            token = $sessionStorage.cookie.get('userToken').token;
            let option = {
                method: method,
                url: url,
                headers: {
                    'Content-Type': params.contentType,
                    token: token,
                },
                data: data,
            };
            if (params.transformRequest) {
                option.transformRequest = params.transformRequest;
            }
            if (isArrayBuffer) {
                option.responseType = 'arraybuffer';
            }
            $http(option).then(
                function (data) {
                    if (data.data.code === '401') {
                        refreshToken().then(function () {
                            deferred.reject();
                            return httpServerForMR(params, data, isArrayBuffer);
                        });
                        deferred.reject(data);
                    }
                    if (data.data.code === '500') {
                        modalDialog.alertType(data.data.code, data.msg || data.data.msg || '发生错误', 'error', false);
                        deferred.reject(data);
                    }
                    if (data.data.code === '200') {
                        deferred.resolve(data.data);
                    } else {
                        if (data.data.message) {
                            modalDialog.alertType(data.data.code, data.data.message || '发生错误', 'error', false);
                            deferred.reject(data.data);
                        } else {
                            deferred.resolve(data.data);
                        }
                    }
                },
                function (data) {
                    if (data.data.code === '401') {
                        refreshToken().then(function () {
                            deferred.reject();
                            return httpServerForMR(params, data, isArrayBuffer);
                        });
                    } else {
                        modalDialog.alertType(data.code, data.statusText, 'error', false);
                        deferred.reject(data);
                    }
                },
            );
            return deferred.promise;
        }

        /**
         * [getURL URL定义和返回]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        function getURL(type) {
            let URLMap = {
                MR: '/bigdata/mr',
                WCMROOT: '/wcm/mlfcenter.do',
            };
            return URLMap[type];
        }

        /**
         * [refreshToken 刷新TOKEN]
         *
         * @return  {[type]}  [return description]
         */
        function refreshToken() {
            var deffer = $q.defer();
            refreshTokenTimes++;
            if (refreshTokenTimes < refreshTokenMaxTimes) {
                let tenantId = $sessionStorage.get('curUserInfo').TENANTID;
                var params = {
                    serviceid: 'getToken',
                    tenantId: tenantId,
                    // methodname: 'test',
                };
                let daysToExpiryForToken = 0.085; // token失效时间2小时
                handlePost(getURL('WCMROOT'), params, 'get').then(function (data) {
                    $sessionStorage.cookie.set('userToken', data, daysToExpiryForToken);
                    localStorageService.set('userToken', data);
                    deffer.resolve({
                        token: $sessionStorage.cookie.get('userToken').token,
                        tenantId: tenantId,
                    });
                });
            } else {
                deffer.reject();
            }

            return deffer.promise;
        }

        /**
         * [handlePost description]
         * @param   {[type]}  url             [url description]
         * @param   {[type]}  params          [params description]
         * @param   {[type]}  type            [type description]
         * @param   {[type]}  forbiddenError  [forbiddenError description]
         * @param   {[type]}  header          [header description]
         * @return  {[type]}                  [return description]
         */
        function handlePost(url, params, type, forbiddenError, header) {
            type = angular.uppercase(type);
            var deferred = $q.defer();
            if (angular.isUndefined(type)) {
                deferred.reject('所需参数type没有传入！');
                return deferred.promise;
            }
            if (type !== 'POST' && type !== 'GET' && type !== 'DELETE') {
                deferred.reject('参数【' + type + '】错误！');
                return deferred.promise;
            }
            var headers = {
                formdata: '1',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            };
            if (header) {
                angular.extend(headers, header);
            }
            $http({
                method: type,
                url: url,
                headers: headers,
                data: type === 'POST' ? params : '',
                params: type === 'POST' ? '' : params,
                timeout: 1000 * 60 * 2, // 设置请求超时时间（暂定2分钟）
            }).success(function (data, status, headers, config) {
                if (headers('TRSNotLogin')) {
                    removeGroupInfo();
                    var addr = headers('IDSLoginUrl');
                    var surl = headers('surl').replace(/(\w+):\/\/([^/:]+)(:\d*)?/, window.location.origin)
                    goToLoginPage(addr, surl);
                    deferred.reject();
                } else if (data === null) {
                    // 当返回值为null时做的处理
                    deferred.reject(data);
                } else if (angular.isDefined(data.ISSUCCESS) && data.ISSUCCESS == 'false') {
                    if (!forbiddenError) {
                        if (angular.isArray(data.REPORTS)) {
                            modalDialog.multiReportsAlert(data, function () {
                                deferred.reject(data);
                            });
                        } else {
                            modalDialog.alertType('', data.DETAIL, 'warning', 'confirm', function () {
                                deferred.reject(data);
                            });
                        }
                    } else {
                        deferred.reject(data);
                    }
                } else if (angular.isDefined(data.status) && data.status === '-1') {
                    if (!forbiddenError) {
                        modalDialog.alertType(
                            data.message,
                            data.detail,
                            'error',
                            'confirm',
                            function () {
                                // $window.close();
                                deferred.reject(data);
                            },
                            function () {
                                deferred.reject(data);
                            }
                        );
                    } else {
                        deferred.reject(data);
                    }
                } else if ((data.code && data.code === '500') || (data.CODE && data.CODE === '500')) {
                    // 500 表示请求失败，直接拦截
                    // 兼容视频上传的返回值
                    modalDialog.alertType('操作失败', data.msg, 'warning');
                    deferred.reject(data);
                } else if ((data.code && data.code === '401')) { // 新增token失效处理方案
                    refreshToken().then(function () {
                        deferred.reject({
                            code: data.code,
                            info: 'token失效'
                        });
                    });
                } else {
                    deferred.resolve(data);
                }
            }).error(function (data, status) {
                messagePublishService.publish('requetDataFailed');
                // modalDialog.alertType('', '连接服务器失败，请稍后重试！', 'error', 'confirm');
                if (status === 500 || status === 503 || status === 504) {
                    modalDialog.requestErrorDialog({
                        status: status,
                        data: data
                    });
                } else if (status === -1) {
                    modalDialog.alertType('提示', '网络异常，请做好备份，待网络恢复后重新操作', 'warning');
                }
                deferred.reject(data);
            });
            return deferred.promise;
        }
    },
]);
